const loc_sl_strings = {
    "Login": {
        "HEADING": "Prijava v platformo MM-ID",
        "LOGIN": "Prijava",
        "USER": "Uporabniško ime",
        "PASSWORD": "Geslo",
        "LOGIN_FAIL": "Prijava ni uspela",
        "LOGIN_FIELD_REQUIRED": "Polje \"Uporabniško ime\" je obvezno",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "FORGOT_PASSWORD": "Ali si pozabil geslo?",
        "DIFFERENT_ACCOUNT": "Prijavi se z drugim računom",
        "NO_ACCOUNT": "Nimaš računa?␣",
        "REGISTER": "Registriraj se z MM digital",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj svojo podporo."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Nadzorna plošča",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "MY_APPLICATIONS_TEXT": "Moje aplikacije MM",
        "APPLICATIONS_TEXT": "Aplikacije MM",
        "USERS_LIST_TEXT": "Upravljanje uporabnikov"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Nadzorna plošča",
        "MY_APPLICATIONS_TEXT": "Moje aplikacije MM",
        "APPLICATIONS_TEXT": "Aplikacije MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Uporabniški meni",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Staro geslo",
        "NEW_PASSWORD": "Novo geslo",
        "CONFIRM_PASSWORD": "Potrdi geslo",
        "PASS_DO_NOT_MATCH": "␣Gesli se ne ujemata",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "OLD_PASSWORD_FIELD_REQUIRED": "Polje \"Staro geslo\" je obvezno",
        "SUCCESS_TEXT": "Geslo je bilo uspešno spremenjeno",
        "HEADING": "Spremeni poverilnice MM-ID",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Spremeni",
        "CANCEL": "Prekliči",
        "PASSWORD_CHANGE_ERROR": "Podatkov ni mogoče shraniti. Poskusi kasneje.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Geslo mora vsebovati vsaj 10 znakov, malo, veliko črko, poseben znak, števko",
        "PASSWORD_REQUIREMENTS_TEXT": "Geslo mora izpolnjevati naslednje zahteve:",
        "LOWERCASE_LETTER_TEXT": "Vsaj ena črka␣ ",
        "UPPERCASE_LETTER_TEXT": "Vsaj ena velika črka",
        "NUMBER_TEXT": "Vsaj ena številka",
        "SPECIAL_SYMBOL_TEXT": "Vsaj en poseben simbol",
        "PASSWORD_LENGTH_TEXT": "Imeti mora vsaj 10 znakov",
        "PASSWORD_RESTRICTION_TEXT": "Ime, priimek in uporabniško ime ne smejo biti del gesla",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj podporno službo."
    },
    "CreatePassword": {
        "PASSWORD": "Ustvari geslo",
        "CONFIRM_PASSWORD": "Potrdi svoje geslo",
        "PASS_DO_NOT_MATCH": "Gesli se ne ujemata",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "SUCCESS_TEXT": "Geslo je bilo uspešno shranjeno",
        "HEADING": "Ustvari geslo",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Spremeni",
        "CANCEL": "Prekliči",
        "PASSWORD_CHANGE_ERROR": "Podatkov ni mogoče shraniti. Poskusi kasneje",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Geslo mora vsebovati vsaj 10 simbolov, malo, veliko črko, poseben znak, števko",
        "PASSWORD_REQUIREMENTS_TEXT": "Geslo mora izpolnjevati naslednje zahteve:",
        "LOWERCASE_LETTER_TEXT": "Vsaj ena črka",
        "UPPERCASE_LETTER_TEXT": "Vsaj ena velika črka",
        "NUMBER_TEXT": "Vsaj ena številka",
        "SPECIAL_SYMBOL_TEXT": "Vsaj en poseben simbol",
        "PASSWORD_LENGTH_TEXT": "Imeti mora vsaj 10 znakov",
        "PASSWORD_RESTRICTION_TEXT": "Ime, priimek in uporabniško ime ne smejo biti del gesla",
        "PASSWORD_WAS_SET": "Povezava je že bila uporabljena za nastavitev gesla, če se ne spomnite gesla, uporabite funkcijo gesla za ponastavitev.",
        "OLD_PASSWORD_REQUIRED": "Polje \"Staro geslo\" je obvezno",
        "MMID_CHANGE_PASSWORD": "Spremeni geslo",
        "OLD_PASSWORD": "Staro geslo",
        "INVALID_OLD_PASSWORD": "Neveljavno staro geslo",
        "USER_NOT_FOUND_OR_INACTIVE": "Uporabnik ne obstaja ali je neaktiven ",
        "UNKNOWN_ERROR": "Med spreminjanjem gesla je prišlo do napake"
    },
    "ForgotPassword": {
        "USER": "E-pošta",
        "LOGIN_FAIL": "Vnesi pravilni E-pošta",
        "LOGIN_FIELD_REQUIRED": "Polje \"E-pošta\" je obvezno",
        "HEADING": "Si pozabil geslo?",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Pošlji e-sporočilo za ponastavitev gesla",
        "CANCEL": "Prekliči",
        "SUCCESS_TEXT": "V nabiralniku preveri, če si prejel e-sporočilo.",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj podporno službo.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkcija ponastavitve gesla je bila prevečkrat uporabljena. Poskusi kasneje. ",
        "RESET_FAILED": "Prijava ni uspela",
        "LINK_EXPIRED": "Povezava za prijavo je potekla. Ponovno vnesite svoj elektronski naslov in prosite za novo povezavo.",
        "HEADING_EXPIRED": "Povezava za prijavo je potekla.",
        "SAVE_EXPIRED": "Zahtevaj povezavo za prijavo."
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "ACTIVE": "Aktiven",
        "INACTIVE": "Neaktiven",
        "MMID": "MMID",
        "EXTRANET": "Zunanji uporabniki",
        "OU": "Organizacijska enota",
        "ORGANIZATION_UNIT": "Organizacijska enota",
        "LANGUAGE": "Jezik",
        "OPEN_FILTER": "Odpri filter",
        "CLOSE_FILTER": "Zapri filter",
        "RESET": "ponastavi",
        "RESET_ALL_FILTERS": "Ponastavi vse filtre",
        "SEARCH": "Išči",
        "STATUS": "Status",
        "GROUPS": "Skupine",
        "SHOW_ALL_DETAILS": "Prikaži vse podrobnosti",
        "SHOW_LESS": "Prikaži manj",
        "ASCENDING": "Naraščajoče",
        "DESCENDING": "Padajoče",
        "LIST_END": "Konec seznama",
        "SORT_BY_LASTNAME": "Razvrsti po priimku",
        "SORT_BY_FIRSTNAME": "Razvrsti po imenu",
        "SORT_BY_EMAIL": "Razvrsti po e-naslovu",
        "SORT_BY_LANGUAGE": "Razvrsti po želenem jeziku",
        "SORT_BY_STATUS": "Razvrsti po statusu",
        "SORT_BY_OU": "Razvrsti po OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Uredi",
        "CREATE": "Nov uporabnik",
        "DIGICREATE": "Novi uporabnik MM digital",
        "EXTRANETCREATE": "Novi uporabnik MM SharePoint Extranet",
        "MMPCREATE": "Novi uporabnik MMP digital",
        "ACTIVATE": "Aktiviraj",
        "DEACTIVATE": "Deaktiviraj",
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "SEND_FORGOT_PW_EMAIL": "Pošlji e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Splošno e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-sporočilo o pozabljenem geslu MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-sporočilo o pozabljenem geslu MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-sporočilo o pozabljenem geslu SP",
        "COMPANY": "Podjetje",
        "SEND_WELCOME_EMAIL": "Pošlji e-sporočilo za dobrodošlico",
        "SEND_WELCOME_EMAIL_DIGI": "E-sporočilo za dobrodošlico MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MM digital",
        "SEND_WELCOME_EMAIL_MMP": "E-sporočilo za dobrodošlico MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MMP digital",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-sporočilo za dobrodošlico SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo SP",
        "APPLY_FILTER_FOR_USERS": "Uporabi filtre ali iskanje za prikaz rezultatov",
        "GENERATING_EMAIL": "Ustvarjanje e-pošte ....",
        "ERROR_EMAIL_GENERATE": "Napaka pri ustvarjanju e-pošte ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "LOADING_USER_ERROR": "Napaka pri nalaganju uporabnika",
        "FIRSTNAME": "Ime",
        "LASTNAME": "Priimek",
        "EMAIL": "E-pošta",
        "ACCOUNT_NAME": "Uporabniško ime za prijavo (predhodniki OS Windows 2000) ",
        "LANGUAGE": "Jezik",
        "PRINCIPAL_NAME": "Glavno uporabniško ime",
        "OU": "Organizacijska enota",
        "CLASS_DISPLAY_NAME": "Prikaži ime",
        "PHONE": "Telefon",
        "WEBSITE": "Spletna stran",
        "COUNTRY": "Država",
        "STATE": "Država",
        "LOCATION": "Mesto",
        "STREET": "Ulica",
        "POSTAL_CODE": "Poštna številka",
        "COMPANY": "Podjetje",
        "DEPARTMENT": "Oddelek",
        "PERSONAL_TITLE": "Osebni naziv",
        "MANAGER": "Vodja",
        "DESCRIPTION": "Opis",
        "GROUPS": "Skupine",
        "SAVE": "Shrani",
        "CANCEL": "Prekliči",
        "USER_STATUS": "Status uporabnika",
        "ACTIVE": "Aktiven",
        "INACTIVE": "Neaktiven",
        "ACTIVATE": "Aktiviraj",
        "DEACTIVATE": "Deaktiviraj",
        "USER_WAS_SAVED": "Uporabnik je bil shranjen",
        "UNKNOWN_ERROR": "Pri shranjevanju uporabnika je prišlo do neznane napake",
        "PROXY_ADDRESSES": "Naslovi posredniških strežnikov",
        "BROWSE": "Prebrskaj",
        "REMOVE": "Odstrani",
        "ONLY_JPG": "Dovoljene so le slike s končnico .jpg!",
        "FILE_SIZE": "Velikost datoteke mora biti manjša od 100KB!",
        "DIMENSIONS": "Največja dimenzija slike je 96x96 pikslov!",
        "SEND_FORGOT_PW_EMAIL": "Pošlji e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Splošno e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-sporočilo o pozabljenem geslu MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-sporočilo o pozabljenem geslu MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-sporočilo o pozabljenem geslu SP",
        "VIRUS_FOUND": "Uporabnika ni bilo mogoče shraniti. V priponki je bila najdena zlonamerna programska oprema. Datoteka ne bo naložena. Kontaktiraj svojega sistemskega skrbnika.",
        "VIRUS_SCANNER_NOT_AVL": "Ni bilo možno preveriti prisotnosti zlonamerne programske opreme v datoteki. Poskusi ponovno kasneje. Če težava ni odpravljena, kontaktiraj svojega sistemskega skrbnika. ",
        "INFO": "Vizitka:",
        "SEND_WELCOME_EMAIL": "Pošlji e-sporočilo za dobrodošlico",
        "SEND_WELCOME_EMAIL_DIGI": "E-sporočilo za dobrodošlico MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MM digital",
        "SEND_WELCOME_EMAIL_MMP": "E-sporočilo za dobrodošlico MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MMP digital",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-sporočilo za dobrodošlico SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo SP",
        "SAVING_USER_SPINNER": "Shranjevanje uporabnika... Prosim, počakaj",
        "DUPLICATE_USER": "Uporabnik že obstaja",
        "GENERATING_EMAIL": "Ustvarjanje e-pošte ....",
        "ERROR_EMAIL_GENERATE": "Napaka pri ustvarjanju e-pošte ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Uporabnik ne obstaja",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Ustvarjanje dobrodošlice E-pošta ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "EMAIL_WAS_SENT": "E-sporočilo je bilo uspešno poslano",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-sporočilo ni bilo poslano. Uporabnik je že aktiviran. Namesto tega uporabi funkcijo 'pošlji e-sporočilo za pozabljeno geslo'.",
        "ERROR_EMAIL_SEND": "Napaka pri poskusu pošiljanja e-sporočila",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-sporočilo ni bilo poslano. Uporabi funkcijo 'pošlji e-sporočilo za registracijo MM digital'.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkcija ponastavitve gesla je bila prepogosto uporabljena. Poskusi ponovno kasneje.",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_sl_strings;



// WEBPACK FOOTER //
// ./src/resources/sl.js